import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/Kaushallokhande/portfolio'
      className='link footer__link'
      target='_blank'
      rel="noreferrer"
    >
      Created By Kaushal
    </a>
  </footer>
)

export default Footer
